import { LessonDto } from './lesson.dto';
import { Lesson } from '@lyceo/shared/plan/util-models';

export function mapLesson(lessonDto: LessonDto): Lesson {
  return {
    id: lessonDto.lessonId.toString(),
    lessonType: lessonDto.lessonType,
    repeatTill: lessonDto.repeatTill,
    scheduledDate: lessonDto.scheduledDate,
    startTime: lessonDto.startTime,
    endTime: lessonDto.endTime,
  };
}
